<template>
    <div v-if="hasLinks" class="video-card">
        <div class="video-thumb" @click="openVideo">
            <img v-if="thumbnail" :src="thumbnail" alt="" @error="thumbError = true" />
            <div v-else class="video-thumb-fallback">
                <v-icon size="48" color="txtMuted">mdi-play-box-outline</v-icon>
            </div>
            <div class="video-play">
                <v-icon size="20" color="#0C0E12">mdi-play</v-icon>
            </div>
        </div>
        <div class="video-info">
            <div v-if="coachName" class="video-coach">{{ coachName }}</div>
            <div class="video-title">{{ currentLink.name }}</div>
            <div v-if="currentLink.description" class="video-sub">{{ currentLink.description }}</div>
        </div>
        <div v-if="links.length > 1" class="video-nav">
            <button class="video-nav-btn" @click="prev"><v-icon size="16">mdi-chevron-left</v-icon></button>
            <span class="video-nav-count">{{ index + 1 }} / {{ links.length }}</span>
            <button class="video-nav-btn" @click="next"><v-icon size="16">mdi-chevron-right</v-icon></button>
        </div>

        <agenda-video-dialog ref="videoDialog" />
    </div>
</template>

<script>
import { db } from "@/utils/Firebase";
import AgendaVideoDialog from "@/components/coach/agenda/AgendaVideoDialog";

export default {
    name: "CoachVideoCard",
    components: { AgendaVideoDialog },
    props: {
        coachId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            links: [],
            coachName: '',
            index: 0,
            thumbError: false,
        }
    },
    computed: {
        hasLinks(vm = this) {
            return vm.links.length > 0
        },
        currentLink(vm = this) {
            return vm.links[vm.index] || {}
        },
        thumbnail(vm = this) {
            if (vm.thumbError || !vm.currentLink.videoId) return null
            return vm.getYoutubeImgUrl(vm.currentLink.videoId)
        },
    },
    async mounted() {
        await this.loadCoach()
    },
    methods: {
        async loadCoach() {
            const vm = this
            if (!vm.coachId) return
            const coach = await db.collection('users').doc(vm.coachId).get()
            const data = coach.data() || {}
            vm.links = data.links || []
            vm.coachName = data.name || ''
            vm.$emit('has-links', vm.hasLinks)
        },
        openVideo() {
            this.$refs.videoDialog.show(this.currentLink)
        },
        prev() {
            this.thumbError = false
            this.index = (this.index - 1 + this.links.length) % this.links.length
        },
        next() {
            this.thumbError = false
            this.index = (this.index + 1) % this.links.length
        },
    },
    watch: {
        coachId() {
            this.index = 0
            this.loadCoach()
        },
    },
}
</script>

<style scoped>
.video-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    overflow: hidden;
}

.video-thumb {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #1a1a2e;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.video-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.video-thumb-fallback {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(160deg, #1a1a2e, #16213e);
}

.video-play {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: rgba(204, 255, 51, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    box-shadow: 0 4px 20px rgba(204, 255, 51, 0.4);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.video-thumb:hover .video-play {
    transform: scale(1.09);
    box-shadow: 0 6px 26px rgba(204, 255, 51, 0.55);
}

.video-info {
    padding: 12px 16px 14px;
}

.video-coach {
    font-size: 11px;
    font-weight: 600;
    color: var(--v-accent-base);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 4px;
}

.video-title {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}

.video-sub {
    font-size: 12px;
    color: var(--v-txtMuted-base);
    margin-top: 2px;
}

.video-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0 16px 12px;
}

.video-nav-btn {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline2-base);
    color: var(--v-txtSecondary-base);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.video-nav-btn:hover {
    background: var(--v-outline2-base);
    color: var(--v-txtPrimary-base);
}

.video-nav-count {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
}
</style>
